export const ErrorCodeClass = {
	root: 'gov-error-code',
	icon: 'gov-error-code__icon',
	holder: 'gov-error-code__holder',
	content: 'gov-error-code__content',
}
